import React from 'react';

const Section = ({children, overlay = false, overlayExtaClassName = 'sec-overlay', className, ...props}) => (
	<section {...props} className={["scroll-section root-sec", className].join(' ')}>
		<div className={overlay ? overlayExtaClassName : ''}>
			<div className="container">
				{children}
			</div>
		</div>
	</section>
);

export default Section;



// WEBPACK FOOTER //
// ./src/components/containers/Section.js